/* ==========================================================================
   Variant Switcher
   Handles: option selection, price (Bold), SKU, add-to-cart state,
            description tabs, image/video carousel, spec sheet link.

   Usage: window.VariantSwitcher.init(productData)

   Depends on (must be ready first):
     - jQuery
     - window.buildProductDetailTab  (product-details.liquid)
     - window.ProductImageViewer     (product-image.js, via 'product-image-ready' event)
   ========================================================================== */

window.VariantSwitcher = (function ($, window, document) {
    'use strict';

    var productData = null;
    var imageViewerReady = false;

    function init(data) {
        productData = data;

        bindQuantityAdjusters();
        bindOptionRadios();

        // Ensure the DOM's checked radios match productData.currentVariantId,
        // regardless of whether Liquid's server-rendered `checked` attribute
        // logic matched correctly. This is the authoritative source for
        // "what's selected on load" going forward.
        selectVariantInDOM(data.currentVariantId);

        updateOptionsAvailability();

        var initialVariant = getCurrentVariant();
        if (initialVariant) {
            //console.log('🚀 Initial variant:', initialVariant.title);
            applyVariant(initialVariant);
        } else {
            console.warn('Could not resolve initial variant from DOM state');
        }
    }

    /**
     * Checks the correct radio in each .product-option to match the given
     * variant id, based on productData.
     */
    function selectVariantInDOM(variantId) {
        var variant = productData.variants.find(function (v) { return v.id === variantId; });
        //console.log('[selectVariantInDOM] variantId:', variantId, '| found:', variant);

        if (!variant) return;

        var optionDivs = document.querySelectorAll('.product-option');
        //console.log('[selectVariantInDOM] optionDivs.length:', optionDivs.length);

        optionDivs.forEach(function (optionDiv, index) {
            var targetValue = variant.options[index];
            var radios = optionDiv.querySelectorAll('input[type="radio"]');
            // console.log('[selectVariantInDOM] index', index, '| targetValue:', targetValue, '| radios found:', radios.length);

            radios.forEach(function (radio) {
                radio.checked = (radio.value === targetValue);
            });
        });
    }

    function getSelectedOptions() {
        var options = [];
        document.querySelectorAll('.product-option').forEach(function (optionDiv) {
            var checked = optionDiv.querySelector('input[type="radio"]:checked');
            options.push(checked ? checked.value : null);
        });
        return options;
    }

    function findVariantByOptions(options) {
        return productData.variants.find(function (variant) {
            return variant.options.every(function (option, index) {
                return option === options[index];
            });
        });
    }

    function getCurrentVariant() {
        return findVariantByOptions(getSelectedOptions());
    }

    function bindOptionRadios() {
        document.querySelectorAll('.product-option input[type="radio"]').forEach(function (radio) {
            radio.addEventListener('change', onOptionChange);
        });
    }

    function onOptionChange(event) {
        // console.log('🔄 Option changed:', event.target.value);

        updateOptionsAvailability();
        autoSelectNextOption();

        var selectedOptions = getSelectedOptions();
        var allSelected = selectedOptions.every(function (opt) { return opt !== null; });

        if (allSelected) {
            var matchedVariant = findVariantByOptions(selectedOptions);
            if (matchedVariant) {
                // console.log('🎯 Matched variant:', matchedVariant.title);
                applyVariant(matchedVariant);
            }
        } else {
            // console.log('⏳ Waiting for all options');
            updateAddToCartButton(null);
        }
    }

    function autoSelectNextOption() {
        var optionDivs = document.querySelectorAll('.product-option');

        for (var i = 1; i < optionDivs.length; i++) {
            var optionDiv = optionDivs[i];
            var checked = optionDiv.querySelector('input[type="radio"]:checked');

            if (!checked) {
                var firstAvailable = optionDiv.querySelector('input[type="radio"]:not(:disabled)');
                if (firstAvailable) {
                    firstAvailable.checked = true;
                    // console.log('🎯 Auto-selected:', firstAvailable.value);
                    updateOptionsAvailability();
                }
            }
        }
    }

    function updateOptionsAvailability() {
        var currentSelections = [];
        document.querySelectorAll('.product-option').forEach(function (optionDiv, position) {
            var checked = optionDiv.querySelector('input[type="radio"]:checked');
            currentSelections[position] = checked ? checked.value : null;
        });
        // console.log('[updateOptionsAvailability] currentSelections:', JSON.stringify(currentSelections));

        document.querySelectorAll('.product-option').forEach(function (optionDiv, optionPosition) {
            var swatches = optionDiv.querySelectorAll('.option-swatch');

            swatches.forEach(function (swatch) {
                var radio = swatch.querySelector('input[type="radio"]');
                var testValue = radio.value;
                var hasMatch;

                if (optionPosition === 0) {
                    hasMatch = productData.variants.some(function (variant) {
                        return variant.available && variant.options[0] === testValue;
                    });
                } else {
                    var testSelections = currentSelections.slice();
                    testSelections[optionPosition] = testValue;

                    hasMatch = productData.variants.some(function (variant) {
                        if (!variant.available) return false;
                        return testSelections.every(function (value, index) {
                            return value === null || variant.options[index] === value;
                        });
                    });
                }

                //console.log('[updateOptionsAvailability] position', optionPosition, '| testValue:', testValue, '| hasMatch:', hasMatch, '| wasChecked:', radio.checked);

                if (hasMatch) {
                    radio.disabled = false;
                    swatch.classList.remove('disabled');
                } else {
                    radio.disabled = true;
                    swatch.classList.add('disabled');
                    if (radio.checked) {
                        //console.warn('[updateOptionsAvailability] UNCHECKING', testValue, 'at position', optionPosition);
                        radio.checked = false;
                    }
                }
            });
        });
    }

    function applyVariant(variant) {
        if (!variant) return;

        updateVariantIdInput(variant);
        updatePrice(variant);
        updateSKU(variant);
        updateAddToCartButton(variant);
        updateDescription(variant);
        updateVariantImages(variant);
        updateSpecSheet(variant);
        updateOptionsAvailability();
    }

    function updateVariantIdInput(variant) {
        var form = document.querySelector('.cart-product-form');
        if (!form) return;

        var variantInput = form.querySelector('input[name="id"]');
        if (!variantInput) {
            variantInput = document.createElement('input');
            variantInput.type = 'hidden';
            variantInput.name = 'id';
            form.insertBefore(variantInput, form.firstChild);
        }
        variantInput.value = variant.id;
    }

    function updatePrice(variant) {
        var variantInput = document.querySelector('input[name="id"]');
        if (variantInput) {
            variantInput.value = variant.id;
        }

        if (typeof BOLD !== 'undefined' && BOLD.common && BOLD.common.eventEmitter) {
            try {
                BOLD.common.eventEmitter.emit('BOLD_COMMON_variant_changed', {
                    variant: {
                        id: variant.id,
                        price: variant.price,
                        compare_at_price: variant.compare_at_price || 0,
                        available: variant.available,
                        sku: variant.sku,
                        title: variant.title
                    }
                });
            } catch (error) {
                console.error('Bold event emit failed:', error);
            }
        } else {
            console.warn('Bold event emitter not available - price may not update');
        }
    }

    function updateSKU(variant) {
        var skuElement = document.querySelector('.variant-sku');
        var skuContainer = document.querySelector('.product-sku');

        if (skuElement && variant.sku) {
            skuElement.textContent = variant.sku;
            if (skuContainer) skuContainer.style.display = '';
        } else if (skuContainer) {
            skuContainer.style.display = 'none';
        }
    }

    function updateAddToCartButton(variant) {
        var button = document.querySelector('.add-to-cart-btn');
        if (!button) return;

        if (variant && variant.available) {
            button.disabled = false;
            button.textContent = 'Add to Cart';
        } else {
            button.disabled = true;
            button.textContent = 'Sold Out';
        }
    }

    function updateDescription(variant) {
        if (typeof window.buildProductDetailTab !== 'function') {
            console.warn('buildProductDetailTab not available yet');
            return;
        }

        if (variant.description && variant.description.trim() !== '') {
            window.buildProductDetailTab(variant.description);
        } else {
            window.buildProductDetailTab();
        }
    }

    function updateSpecSheet(variant) {
        var specSheetLink = document.querySelector('.spec-sheet a');
        if (!specSheetLink || !variant.sku) return;

        var baseUrl = 'https://app.kira-home.com/SpecSheet.html';
        specSheetLink.href = baseUrl + '?sku=' + encodeURIComponent(variant.sku);
    }

    function getOriginalImage(url) {
        if (!url) return '';
        return url.replace(/\.(305w|190x190)\.(jpg|jpeg|png|webp)$/i, '.$2');
    }

    function updateVariantImages(variant) {
        var mediaItems = variant.images || [];
        if (mediaItems.length === 0) {
            console.warn('No media for variant:', variant.title);
            return;
        }

        var thumbnailsHTML = mediaItems.map(function (item, index) {
            if (item.type === 'image') {
                var mainUrl = getOriginalImage(item.url);
                return (
                    '<div class="thumbnail-item">' +
                    '<img src="' + (item.thumbnail_url || item.url) + '" ' +
                    'alt="' + escapeAttr(variant.title) + '" ' +
                    'data-main-image="' + mainUrl + '" ' +
                    'data-full-image="' + mainUrl + '" ' +
                    'data-media-type="image" ' +
                    'data-slide-index="' + index + '" ' +
                    'data-size="1900x1900" ' +
                    'width="80" height="80" />' +
                    '</div>'
                );
            }

            var size = (item.width || 1920) + 'x' + (item.height || 1080);
            return (
                '<div class="thumbnail-item">' +
                '<div class="media-thumbnail-wrapper prlightbox">' +
                '<img src="' + item.thumbnail_url + '" ' +
                'alt="Video: ' + escapeAttr(variant.title) + '" ' +
                'data-media-type="' + item.media_type + '" ' +
                "data-video-html='" + item.video_html.replace(/'/g, '&apos;') + "' " +
                'data-slide-index="' + index + '" ' +
                'data-size="' + size + '" ' +
                'width="80" height="80" />' +
                '<i class="ad ad-play"></i>' +
                '</div>' +
                '</div>'
            );
        }).join('');

        if (imageViewerReady && window.ProductImageViewer) {
            window.ProductImageViewer.unslickCarousel();
            $('.carousel-thumbnails').html(thumbnailsHTML);
            window.ProductImageViewer.initImageCarousel();

            var firstThumbImg = document.querySelector('.thumbnail-item img');
            if (firstThumbImg) {
                window.ProductImageViewer.setActiveThumbnail(firstThumbImg);
                window.ProductImageViewer.showMediaInMainArea(firstThumbImg);
            }
        } else {
            console.warn('ProductImageViewer not ready yet - carousel not reinitialized');
            $('.carousel-thumbnails').html(thumbnailsHTML);
        }

        setTimeout(function () {
            $(document).trigger('rebind-photoswipe');
        }, 300);
    }

    function escapeAttr(str) {
        return String(str || '').replace(/"/g, '&quot;');
    }

    function bindQuantityAdjusters() {
        document.querySelectorAll('.qty-adjust').forEach(function (button) {
            button.addEventListener('click', function () {
                var input = this.parentElement.querySelector('.qty-input');
                var value = parseInt(input.value, 10);

                if (this.dataset.adjust === 'up') {
                    input.value = value + 1;
                } else if (this.dataset.adjust === 'down' && value > 1) {
                    input.value = value - 1;
                }
            });
        });
    }

    $(document).on('product-image-ready', function () {
        imageViewerReady = true;
    });

    return {
        init: init
    };

})(jQuery, window, document);